export default __webpack_public_path__ + "static/media/notification.b71335b8.png";